import axios from 'axios';
import { auth } from '../firebase/firebase'; // adjust if needed

// Helper to get token (fallback to fresh)
const getFreshToken = async () => {
  try {
    return await auth.currentUser.getIdToken(); // cached
  } catch {
    return await auth.currentUser.getIdToken(true); // refresh
  }
};

// Create a new Axios instance
const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`, // your backend URL
});
// Interceptor to add token automatically
axiosInstance.interceptors.request.use(
  async (config) => {
    const user = auth.currentUser;
    if (user) {
      const token = await getFreshToken();
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
